/* eslint-disable @typescript-eslint/no-explicit-any */
import { lazy, ComponentType } from 'react'
import { useIsSmavaTenant } from '../context/tenantContext'

export const useComponentSwitch = <
  S extends ComponentType<any>,
  F extends ComponentType<any>,
>(
  smavaVariant: () => Promise<{ default: S }>,
  fcVariant: () => Promise<{ default: F }>,
) => {
  const isSmavaTenant = useIsSmavaTenant()

  if (isSmavaTenant) {
    return lazy<S>(smavaVariant)
  }

  return lazy<F>(fcVariant)
}
